const url = "https://chatapp-trivandeptraivodichvutru.onrender.com/"
// const url = "http://localhost:3001/"
export default url